export default {
  findRouteByQuote: {
    method: 'post',
    url: '/client/order/route/find-by-quote'
  },
  findRouteByQuoteRequestData: {
    method: 'post',
    url: '/client/order/route/find-by-data-quote-request'
  }
}
